/**
 * What Android's back button does, decided without a screen.
 *
 * An open sheet closes first — the way every Android app behaves, and the
 * only way out of a sheet that does not move the screen underneath it. Then
 * history is walked. At the numpad, or with nothing left to walk, the app is
 * left. Pure, so the order is tested rather than remembered.
 */

export type BackAction = "dismiss" | "back" | "exit";

export function backAction({
  canGoBack,
  pathname,
  dialogOpen,
}: {
  /** The WebView has history behind the current entry. */
  canGoBack: boolean;
  pathname: string;
  /** A dialog (a sheet, a confirmation) is on screen. */
  dialogOpen: boolean;
}): BackAction {
  if (dialogOpen) return "dismiss";
  if (canGoBack && pathname !== "/") return "back";
  return "exit";
}
